import { useTranslation } from 'react-i18next'
import { Construction } from 'lucide-react'

import { CatalogListPageShell } from '@/shared/components/catalog/CatalogListPageShell'
import { PageEmptyState } from '@/shared/components/PageEmptyState'

type StudioComingSoonPageProps = {
  mode: 'production' | 'writer' | 'creative'
}

const TITLE_KEY: Record<StudioComingSoonPageProps['mode'], string> = {
  production: 'modeHub.productionTitle',
  writer: 'modeHub.writerTitle',
  creative: 'modeHub.creativeTitle',
}

/** PR-1 占位：后续 PR 迁入对应模块页面 */
export function StudioComingSoonPage({ mode }: StudioComingSoonPageProps) {
  const { t } = useTranslation()

  return (
    <CatalogListPageShell>
      <PageEmptyState
        icon={Construction}
        tone="indigo"
        title={t(TITLE_KEY[mode])}
        subtitle={t('studio.migrationPending')}
      />
    </CatalogListPageShell>
  )
}
